import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import ErrorMessage from 'components/common/ErrorMessage';
import BoxQuestionsToggles from 'components/signUpFunnel/shared/BoxQuestionsToggles';
import useAnalyticsEffect from 'hooks/useAnalyticsEffect';
import useBoxRecommender from 'hooks/useBoxRecommender';
import { TEMPO, BOX_RECOMMENDER_PATHS } from 'lib/constants';
import { events } from 'services/analytics';

import ContinueButton from './ContinueButton';
const BoxQuestions = ({ pathname, goNext }) => {
  const errorRef = useRef(null);

  const { BOX_PEOPLE, BOX_MEALS, BOX_DAYS } = BOX_RECOMMENDER_PATHS;

  const pageEvents = pathname.includes(BOX_PEOPLE)
    ? events.pickMeals[TEMPO].boxPeople
    : pathname.includes(BOX_MEALS)
      ? events.pickMeals[TEMPO].boxMeals
      : pathname.includes(BOX_DAYS)
        ? events.pickMeals[TEMPO].boxDays
        : undefined;

  useAnalyticsEffect(
    ({ logEvent }) => {
      if (!pageEvents) return;

      logEvent(pageEvents.viewed, {
        mealPlanSlug: TEMPO,
      });
    },
    [pageEvents]
  );

  const {
    error,
    isSubmitting,
    handleContinueClick,
    handleBoxSignupAnswerClick,
    boxSignupData,
    icons,
  } = useBoxRecommender({
    boxRecommenderPath: pathname,
    mealPlanSlug: TEMPO,
    onNavigate: goNext,
    location: { amplitudePageSubmitted: pageEvents?.submitted },
  });

  return (
    <>
      <BoxQuestionsToggles
        boxSignupData={boxSignupData}
        handleBoxSignupAnswerClick={handleBoxSignupAnswerClick}
        icons={icons}
        pathname={pathname}
      />
      <ContinueButton
        onContinue={handleContinueClick}
        disabled={isSubmitting}
        submittingText="Continue"
      />
      <CSSTransition
        in={Boolean(error)}
        classNames="fadeInOut"
        timeout={200}
        nodeRef={errorRef}
        unmountOnExit
      >
        <div ref={errorRef}>
          <ErrorMessage message={error} />
        </div>
      </CSSTransition>
    </>
  );
};

BoxQuestions.propTypes = {
  pathname: PropTypes.string,
  goNext: PropTypes.func,
};

export default BoxQuestions;
